<!-- =========================================================================================
    File Name: Login.vue
    Description: Login Page
    ----------------------------------------------------------------------------------------
      Author: Moddather Rashed
========================================================================================== -->


<template>
  <div class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center" id="page-login">
    <div class="m-4">
      <vx-card>
        <div slot="no-body">

          <div class="vx-row no-gutter justify-center items-center">
            <div class="d-theme-dark-bg">
              <div class="p-8 login-tabs-container">

                <div class="vx-card__title mb-4">
                  <h4 class="mb-4">Anmelden</h4>
                  <p>Willkommen zurück, bitte loggen Sie sich in Ihr Konto ein.</p>
                </div>

                <form @submit.prevent="onLoginPress">
                  <vs-input
                    required
                    name="email"
                    icon-no-border
                    type="email"
                    icon="icon icon-user"
                    icon-pack="feather"
                    label-placeholder="E-Mail"
                    v-model="login.email"
                    class="w-full"/>

                  <vs-input
                    required
                    type="password"
                    name="password"
                    icon-no-border
                    icon="icon icon-lock"
                    icon-pack="feather"
                    label-placeholder="Passwort"
                    v-model="login.password"
                    class="w-full mt-6"/>

                  <div class="flex flex-wrap justify-between my-5">
                    <!--  <router-link to="">Forgot Password?</router-link>-->
                    {{error}}
                    </div>
                  <div class="flex flex-wrap justify-end">
                    <button class="button button--primary" type="submit">Login</button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
  import {mapActions} from 'vuex'

  export default {
    data() {
      return {
        error: '',
        login: {
          email: "",
          password: "",
        }
      }
    },
    methods: {
      ...mapActions(['fetchCurrentUser']),
      onLoginPress() {
        this.fetchCurrentUser(this.login)
          .then((res) => {
            console.log("Rrdponse",res)
            if (res === true) {
              window.location.assign(window.location.origin)
            } else {
              this.error = 'Falsche Email oder Passwort'
            }
          })
      }
    }
  }
</script>


<style>
  body {
    padding: 0;
  }
</style>
